var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCessna(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.25,85.07l-0.08-1.08h-3.52l-5.97-0.36v-7.12l5.78-1.76h3.06l-1.82-25.4H25.16L2.47,46.17v-9.75l22.56-0.46h19.21v-8.89 h0.03c0.22-3.87,1.87-12.69,5.38-12.69s5.16,8.82,5.38,12.69h0.02l0.01,1v7.89h19.03l22.24,0.46v9.75l-21.99,3.18H54.61l-1.82,25.4 h3.01l5.83,1.76v7.12l-5.87,0.36l-3.62,0l-0.08,1.08H47.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.08,36.96H54.05v-8.89h-0.01c0-0.07,0.01-0.13,0.01-0.19c0-4.14-1.97-12.5-4.41-12.5 c-2.43,0-4.41,8.36-4.41,12.5c0,0.07,0,0.13,0.01,0.19h-0.01v8.89H25.06L3.47,37.39v7.9l21.76,3.05h20.39l1.96,27.4H43.6l-4.93,1.5 v5.44l4.97,0.3h4.46l0.08,1.08h2.94l0.08-1.08h4.49l4.93-0.3v-5.44l-4.98-1.5h-3.93l1.96-27.4h20.58l21.07-3.05v-7.9L74.08,36.96z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCessna);
export default __webpack_public_path__ + "static/media/cessna.e4cb714d.svg";
export { ForwardRef as ReactComponent };